/* ============================================================
   TLC ACCESSIBILITY — keyboard support for dropdowns
   ============================================================ */
(function(){
  "use strict";
  document.querySelectorAll(".tlc-dropdown > button").forEach(function(btn){
    btn.setAttribute("aria-haspopup","true");
    btn.setAttribute("aria-expanded","false");
    btn.addEventListener("click", function(){
      var expanded = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", String(!expanded));
    });
  });
  document.addEventListener("keydown", function(e){
    if(e.key === "Escape"){
      document.querySelectorAll(".tlc-dropdown > button[aria-expanded=true]").forEach(function(btn){
        btn.setAttribute("aria-expanded","false");
        btn.blur();
      });
    }
  });
})();
